import { call, put, takeEvery } from "redux-saga/effects";
import {
    AuthActionTypes,
    DisconnectIntegrationRequestActionType,
    IDisconnectIntegrationSuccessData,
} from "../../auth/types";
import { FormsService } from "../../../services/forms";
import { disconnectIntegrationFailure, disconnectIntegrationSuccess } from "../../auth/actionCreators";

function* handleDisconnectIntegration(action: DisconnectIntegrationRequestActionType) {
    try {
        const { type } = action.payload;

        const response: { data: IDisconnectIntegrationSuccessData } = yield call(
            FormsService.disconnectIntegration,
            type,
        );

        yield put(disconnectIntegrationSuccess(response.data));
    } catch (error: any) {
        yield put(
            disconnectIntegrationFailure(
                error.response?.data ? error.response?.data : error.message ? { message: error.message } : error,
            ),
        );
    }
}

export function* watchDisconnectIntegration() {
    yield takeEvery<DisconnectIntegrationRequestActionType>(
        AuthActionTypes.DISCONNECT_INTEGRATION_REQUEST,
        handleDisconnectIntegration,
    );
}
